<template>
	<!-- v-touch:right="onSwipeLeft" -->
	<div id="app">
		<router-view />
		<div v-if="is_show_footer" class="footer">
			<router-link to="/" class="footer_item" :class="show_icon_type === 'index' ? 'footer_item_active' : ''">
				<span class="iconfont icon-fangkuai" />
				<!-- <p class="footer_info">
					{{ $t('home.index') }}
				</p> -->
			</router-link>
			<router-link to="/equipe" class="footer_item" :class="show_icon_type === 'equipe' ? 'footer_item_active' : ''">
				<span class="iconfont icon-zhifeiji" />
				<!-- <p class="footer_info">
					{{ $t('home.item') }}
				</p> -->
			</router-link>
			<!-- <router-link to="/contract" class="footer_item" :class="show_icon_type === 'contract' ? 'footer_item_active' : ''">
				<span class="footer_icon footer_icon_cart" />
				<p class="footer_info">
					{{ $t('home.contract') }}
				</p>
			</router-link> -->
			<!-- <router-link to="/journalism" class="footer_item"
				:class="show_icon_type === 'journalism' ? 'footer_item_active' : ''">
				<span class="footer_icon footer_icon_cart" />
				<p class="footer_info">
					{{ $t('新闻资讯') }}
				</p>
			</router-link> -->
			<router-link to="/mine" class="footer_item" :class="show_icon_type === 'mine' ? 'footer_item_active' : ''">
				<span class="iconfont icon-name-card" />
			</router-link>
		</div>
		<div v-show="real_name" class="real_name_mask">
			<div class="real_box">
				<div class="tit" />
				<p class="tips">
					{{ $t('cash.setPwdFirst') }}
				</p>
				<div class="basic_btn" @click="real_name = false">
					{{ $t('cash.setNow') }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/font/iconfont.css'
import {
	Dialog
} from 'vant';
import Fetch from "./utils/fetch";
import { onLang } from '@/utils/toLang'
export default {
	name: 'App',
	data() {
		return {
			show_icon_type: 'index',
			real_name: false,
			is_show_down_app: true,
			is_show_footer: true,
			sync_timer: null,
			app: {},
		}
	},
	updated() {
		document.body.scrollTop = 0
		document.documentElement.scrollTop = 0
	},
	mounted() {
		this.start()
		this.getLang()
	},
	methods: {
		getLang() {
			Fetch("/index/default_lang").then((r) => {
				let lang = localStorage.getItem("lang");
				if (r.data.default_lang && !lang) {
					localStorage.setItem("lang", r.data.default_lang);
				}
				lang = localStorage.getItem("lang");
				this.$i18n.locale = lang;
			});
		},
		onSwipeLeft(even, start, end) {
			console.log(even);
			if (end['X'] - start['X'] > 60) {
				this.$router.go(-1);
			}
		},
		bigNumeber(str) {
			var str = str.toString();
			var strs = str.split(".");
			var s1 = strs[0] || 0;
			var s2 = strs[1] || "00"
			return `<span class="bigNum">${s1}</span><span>.</span><span>${s2}</span>`;
		},
		numFilter(value) {
			let transformVal = parseFloat(value).toFixed(3)
			let realVal = transformVal.substring(0, transformVal.length - 1)
			return parseFloat(realVal)
		},
		footer: function (type = 'index', show_footer = true) {
			console.log(type, show_footer)
			if (type == 'walfare') {
				document.getElementById('app').style.paddingBottom = '0';
			} else {
				document.getElementById('app').style.paddingBottom = '0';
			}
			this.show_icon_type = type;
			console.log('this.show_icon_type',this.show_icon_type)
			this.is_show_footer = show_footer;
		},
		start() {
			Fetch("/index/webconfig").then((r) => {
				this.app = r.data;
				window.document.title = r.data.title;
				const link = document.querySelector('link[rel="icon"]');
				link.href = r.data.icon;
				localStorage.setItem('logo', r.data.logo)
				localStorage.setItem('web_name', r.data.web_name)
			});

			// this.sync_timer = setInterval(() => {
			// 	this.sync()
			// }, 3000);
		},
		closeDownApp() {
			this.is_show_down_app = false;
		},
		sync() {
			/* Fetch("/index/sync", {}, null, false).then((r) => {
				 if (r.data.is_open_notice_dialog) {
					 this.openNoticeDialog();
				 }
			 }); */
		},
		close() {
			this.show_anwser = false;
		},
		openNoticeDialog() {
			Dialog.confirm({
				title: '提示',
				message: '您有新消息，是否前往查看?'
			}).then(() => {
				this.$router.push('/notice');
			}).catch(() => {

			});
		},
	}
}
</script>
<style lang="less">
// @import "./assets/font/font.css";
* {
	touch-action: manipulation;
}

.bgImg {
	width: 100%;
	height: 100%;
	min-height: 950px;
	display: block;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	z-index: 1;
	opacity: 0.8;
	max-width: 750px;
	object-fit: cover;
}

.kefus {
	width: 100%;
	height: fit-content;
	padding: 20px 20px 0 20px;
	font-size: 28px;
	font-weight: bold;
	color: #fff;
}

.kefu {
	width: fit-content;
	height: 80px;
	position: fixed;
	z-index: 10;
	right: 13px;
	bottom: 50px;
	transition: all 1s;
	opacity: 1;
	transform: translateX(0);
	z-index: 80;

	img {
		width: 100%;
		height: 100%;
	}
}

.kefu.kefu_hide {
	transform: translateX(70%);
	opacity: 0.5;
}

.numberFont {
	font-family: barlow !important;
	font-size: 15px !important;
	font-weight: bold !important;

	span:nth-of-type(3) {
		font-size: 14px !important;
	}

	span:nth-of-type(4) {
		font-size: 12px !important;
	}
}

html,
body {
	width: 100%;
	height: 100%;
	overflow-y: scroll !important;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
	width: 0px;
	height: 0px;
}

body {
	margin: 0;
}

.bigNum {
	font-size: 18px !important;
}

.fh {
	font-size: 12px !important;
}

.larfont .fh {
	margin-top: 3px;
}

.wan {
	font-size: 14px;
	margin-top: 2px;
}

.numberFontBold {
	span:first-child {
		font-size: 12px;
		margin-top: 4px;
	}

	span:last-child {
		margin-top: 2px;
	}
}

#app {
	min-height: 100%;
	height: auto;
	width: 100%;
	max-width: 375px;
}

#app .download_box {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	position: fixed;
	margin: 0 auto;
	left: 0;
	right: 0;
	height: 45px;
	width: 100%;
	max-width: 375px;
	background: rgba(0, 0, 0, 0.5);
	bottom: 50px;
	padding: 0 3.6%;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
	z-index: 10;
}

#app .download_box .down {
	-webkit-box-flex: 1;
	-ms-flex: 1 1 auto;
	flex: 1 1 auto;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	padding-right: 10px;
}

#app .download_box .down .down_left {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
}

#app .download_box .down .down_left .app_logo {
	display: inline-block;
	width: 40px;
	height: 40px;
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;
	background-image: url(./views/images/home/app_logo.svg);
	margin-right: 14px;
	;
}

#app .download_box .down .down_left .app_info {
	font-size: 12px;
	color: #fff;
	line-height: 1.5;
	;
}

#app .download_box .down .right {
	background: #D8232C;
	padding: 5px 5px;
	color: #ffffff;
	border-radius: 5px;
	font-size: 12px;
}

#app .download_box .close_down {
	-webkit-box-flex: 0;
	-ms-flex: 0 0 20px;
	flex: 0 0 20px;
	height: 45px;
	;
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;
	background-image: url(./views/images/home/close.svg);
}

#app .footer {
	position: fixed;
	max-width: 750px;
	margin: 0 auto;
	left: 0;
	right: 0;
	-webkit-box-flex: 0;
	-ms-flex: 0 0 48px;
	flex: 0 0 48px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-pack: distribute;
	justify-content: space-around;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	background: #071417;
	box-shadow: 0px 2px 10px 0px #0D342A;
	width: 100%;
	bottom: 0;
	height: 60px;
	z-index: 4;
}

#app .footer .footer_item {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	cursor: pointer;
	color: #999999;
	width: 25%;
}

#app .footer .footer_item .footer_icon {
	display: inline-block;
	width: 26px;
	height: 26px;
	line-height: 26px;
	text-align: center;
	font-size: 24px;
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;
	margin-bottom: 6px;
}

#app .footer .footer_item {
	.iconfont {
		font-size: 30px;
		color: #87A89D;
	}
}

#app .footer .footer_item .footer_icon.footer_icon_home {
	background-image: url(./views/images/common/home.png);
}

#app .footer .footer_item .footer_icon.footer_icon_task {
	background-image: url(./views/images/common/item.png);
}

#app .footer .footer_item .footer_icon.footer_icon_cart {
	background-image: url(./views/images/common/xw.png);
}


#app .footer .footer_item .footer_icon.footer_icon_user {
	background-image: url(./views/images/common/user.png);
}

#app .footer .footer_item .footer_info {
	font-size: 12px;
	text-align: center;
	overflow-wrap: break-word;
	/* 旧版语法，兼容性更好 */
	word-wrap: break-word;
}

#app .footer .footer_item.footer_item_active {
	.iconfont {
		color: #69DEB1;
	}
}

#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_home {
	background-image: url(./views/images/common/home_cur.png);
}

#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_task {
	background-image: url(./views/images/common/item_cur.png);
}

#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_cart {
	background-image: url(./views/images/common/xws.png);
}

#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_user {
	background-image: url(./views/images/common/user_cur.png);
}

.red_top_bg {
	width: 100%;
	max-width: 750px;
	height: 44px;
	margin: 0 auto;
	background: #FFF;
	background-size: 100% 100%;
}

.top_right {
	position: absolute;
	font-size: 13px;
	line-height: 18px;
	color: #FFFFFF;
	top: 16px;
	right: 14px;
}

.limit {
	height: 20px;
	line-height: 20px;
	border-radius: 10px;
	background: rgba(241, 34, 17, 0.08);
	color: #f12211;
	text-align: center;
	padding: 0 7px;
	border: 1px solid #f12211;
	font-size: 12px;
}

.gray_btn {
	height: 20px;
	display: flex;
	align-items: center;
	background: rgba(0, 0, 0, 0.3);
	font-size: 12px;
	text-align: center;
	color: #FFFFFF;
	border-radius: 10px;
	padding: 0 9px;
}

.big_tit {
	position: absolute;
	height: 25px;
	font-size: 18px;
	font-weight: 500;
	line-height: 25px;
	top: 12px;
	left: 50%;
	transform: translateX(-50%);
}

.sub_btn {
	background: linear-gradient(123deg, #e3382e, #ff4d15);
	height: 36px;
	line-height: 36px;
	font-size: 12px;
	color: #FFFFFF;
	text-align: center;
	width: 94px;
	border-radius: 18px;
}

.remove_btn {
	background: linear-gradient(117deg, rgba(254, 166, 0, 1) 0%, rgba(255, 188, 0, 1) 100%);
	height: 36px;
	line-height: 36px;
	font-size: 12px;
	color: #FFFFFF;
	text-align: center;
	width: 94px;
	border-radius: 18px;
}

.text-phone {
	height: 100%;
	display: flex;
	align-items: flex-end;
	padding-bottom: 6px;
	color: #999;
}

.home_tit {
	width: 100%;
	height: 22px;
	line-height: 22px;
	display: flex;
	align-items: center;
	justify-content: center;

	.line {
		width: 75px;
		height: 2px;
	}

	h5 {
		font-size: 16px;
		line-height: 22px;
		color: #000000;
		margin: 0 10px;
		font-weight: bold;
	}
}

.van-popup {
	max-width: 100%;
	margin: 0 auto;
	right: 0;
}

.back_left {
	width: 20px;
	height: 20px;
	background: url(./views/images/item/back.png) no-repeat center center;
	background-size: auto 100%;
	margin: 12px 0 0 8px;
}

.van-checkbox__icon {
	background: #fff;
}

.basic_btn {
	height: 42px;
	line-height: 42px;
	font-size: 14px;
	width: 90%;
	background: #2C8B71;
	border-radius: .5em;
	color: #ffffff;
	text-align: center;
	cursor: pointer;
}

.basic_btn.no_touch {
	color: rgba(255, 255, 255, 0.5);
}

.flex_center {
	display: flex;
	justify-content: center;
	align-items: center;
}

.wrap_box {
	width: 100%;
	background: rgba(255, 255, 255, 1);
	box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
	border-radius: 6px;
}

.eye_bi {
	width: 21px;
	height: 25px;
	background: url(./views/images/user/eye2.png) no-repeat center center;
	background-size: 100% auto;

	&.eye {
		background: url(./views/images/user/eye1.png) no-repeat center center;
		background-size: 100% auto;
	}
}
button {
	cursor: pointer;
}
.real_name_mask {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 2005;
	background-color: rgba(0, 0, 0, 0.85);

	.real_box {
		width: 272px;
		height: 185px;
		background: linear-gradient(90deg, rgba(26, 74, 105, 1) 0%, rgba(21, 56, 84, 1) 100%);
    	padding: 15px;
    	border: 1px solid #375F7A;
		border-radius: 10px;
		position: absolute;
		top: 50%;
		left: 0;
		right: 0;
		margin: -92px auto 0 auto;

		.tit {
			width: 77px;
			height: 67px;
			position: absolute;
			top: -35px;
			left: 50%;
			transform: translateX(-50%);
			background: url(./views/images/user/tit.png) no-repeat center center;
			background-size: 100% 100%;
		}

		.tips {
			width: 190px;
			height: 50px;
			text-align: center;
			font-size: 20px;
			color: #C4CFD6;
			line-height: 25px;
			position: absolute;
			top: 49px;
			left: 50%;
			transform: translateX(-50%);
			white-space: normal;
      		overflow-wrap: break-word;
      		hyphens: auto; /* 可选：自动添加连字符 */
		}

		.basic_btn {
			width: 225px;
			position: absolute;
			left: 0;
			right: 0;
			margin: 0 auto;
			bottom: 15px;
		}
	}
}

.contract_box img {
	width: 100%;
}

.color_blue {
	color: #275ed4;
}

.color_green {
	color: #18be3c;
}

.color_yellow {
	color: #e2d414;
}

.color_red {
	color: #ee4b2e;
}

.table_box {
	width: 100%;
	height: fit-content;
	padding: 0px;

	.uls {
		width: 100%;
		height: fit-content;
		display: flex;
		flex-direction: column;

		.li_box {
			width: 100%;
			height: fit-content;
		}

		.li {
			width: 100%;
			position: relative;
			padding: 5px 6px;
			display: flex;
			font-size: 12px;
			border-bottom: 1px solid #fff;
			height: 24px;

			.jindu1,
			.jindu2 {
				height: 22px;
				position: absolute;
				right: 0;
				top: 50%;
				transform: translateY(-50%);
				z-index: 0;
			}

			.jindu1 {
				background: rgba(216, 35, 35, 0.3);
			}

			.jindu2 {
				background: rgba(43, 142, 81, 0.3);
			}

			.t:nth-child(1),
			.ts:nth-child(1) {
				width: 65%;
				font-weight: bold;
			}

			.t:nth-child(2),
			.ts:nth-child(2) {
				width: 35%;
				text-align: right;

				span {
					position: absolute;
					z-index: 10;
					color: #fff;
					right: 4px;
					top: 50%;
					transform: translateY(-50%);
				}
			}

			.t {
				font-size: 14px;
			}

			.ts {
				color: #eee;
			}
		}

		.t {
			font-size: 16px;
		}

		.s {
			display: block;
			width: 18px;
			height: 18px;
			background: url(./assets/images/s.png) no-repeat center center / 100%;
		}

		.j {
			display: block;
			width: 18px;
			height: 18px;
			background: url(./assets/images/j.png) no-repeat center center / 100%;
		}

		.li_t {
			display: flex;
			align-items: flex-end;
			background: #06190D;
			color: #2B8E51;

			.color_red {
				color: #D8232C !important;
			}

			.tt {
				font-size: 16px;
				font-weight: bold;
			}

			.g {
				color: #d4d3d3;
			}
		}

		.li_red {
			background: #1F080E;

			.ts:nth-child(1) {
				color: #8d3952;
			}
		}

		.li_green {
			background: #06190D;

			.ts:nth-child(1) {
				color: #2B8E51;
			}
		}
	}
}

@media screen and (min-width: 750px) {
	.van-popup--bottom {
		max-width: 750px;
		left: 50% !important;
		transform: translateX(-50%) !important;
	}
}

.tab-item {
	cursor: pointer;
}

.investment-container {
	min-height: fit-content;
	padding:0px 15px 10px 15px;
	font-family: Arial, sans-serif;

	/* 顶部标签栏 */
	.tab-bar {
		display: flex;
		justify-content: space-between;
		margin-bottom: 24px;
	}
	.tab-item:nth-child(1) {
		margin-left: 0px;
	}
	.tab-item {
		flex: 1;
		margin-left: 5px;
		background-color: #0F2A24;
		border: 1px solid #374B49;
		border-radius: 4px;
		padding: 10px 3px;
		color: #94a3b8;
		font-size: 11px;
		cursor: pointer;
		text-align: center;
		white-space: nowrap;
		position: relative;
		transition: all 0.3s ease;
		overflow: hidden;
		cursor: pointer;
	}

	.tab-item.active {
		background:rgba(249,211,66,0.1);
		border-color: #f9d342;
		color: #f9d342;
		font-weight: bold;
	}

	.tab-item.new .new-tag,
	.tab-item.hot .hot-tag {
		position: absolute;
		top: 0px;
		left: 0px;
		font-size: 8px;
		font-weight: bold;
		padding: 2px;
		border-radius: 0px 0px 5px 0px;
	}

	.tab-item.new .new-tag {
		background-color: #ff3b30;
		color: white;
	}

	.tab-item.hot .hot-tag {
		background-color: #ff9500;
		color: white;
	}

	/* 投资卡片 */
	.investment-card {
		height: 142px;
		position: relative;
		background: #124646;
		background: linear-gradient(90deg, rgba(18, 70, 70, 1) 0%, rgba(15, 59, 70, 1) 100%);
		border-radius: 16px;
		display: flex;
		overflow: hidden;
		margin-bottom: 15px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
	}

	.investments {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		z-index: 1;
		background: rgba(0,0,0,0.5);
	}

	.card-avatar {
		width: 35%;
		background-color: white;
		clip-path: polygon(0 0, 100% 0, 85% 100%, 0 100%);
	}

	.card-avatar img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.card-content {
		width: 65%;
		padding: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		
	}

	.card-title {
		height: fit-content;
		background:rgba(14,83,81,0.9);
		color: #72F4AD;
		border: 1px solid #1E6860;
		padding: 4px 8px;
		border-radius: 6px;
		font-size: 12px;
		font-weight: bold;
		white-space: nowrap; 
		/* 3. 超出容器的部分隐藏 */
		overflow: hidden; 
		/* 4. 超出部分显示省略号（核心） */
		text-overflow: ellipsis; 
	}

	.card-stats {
		display: flex;
		justify-content: space-between;
	}

	.stat-item {
		width: fit-content;
		display: flex;
		flex-direction: column;
		margin-right: 5px;
	}

	.stat-item:last-child {
		margin-right: 0px;
	}
	.stat-value {
		font-size: 11px;
		color: white;
		margin-bottom: 4px;
	}

	.stat-value.profit {
		color: #4cf0d0;
	}

	.stat-label {
		font-size: 10px;
		color: #61AFA0;
		white-space: nowrap;
	}

	.subscribe-btn {
		background-color: #34D399;
		border: none;
		border-radius: 6px;
		padding: 8px 14px;
		color: #222;
		font-size: 12px;
		font-weight: bold;
		cursor: pointer;
		width: fit-content;
		transition: background-color 0.3s ease;
	}

	.subscribe-btn:hover {
		background-color: #3bc053;
	}

	.card-tip {
		font-size: 10px;
		color: #6B9B8D;
	}
}

.transition-colors {
	transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
	transition-timing-function: cubic-bezier(.4, 0, .2, 1);
	transition-duration: .15s;
}

.text-emerald-300 {
	--tw-text-opacity: 1;
	color: rgb(110 231 183 / 1);
}

.van-dialog {
	background-color: #0D342A !important;
	background-image: radial-gradient(circle at 82% 12%, rgba(52, 211, 153, 0.21), transparent 45%), radial-gradient(circle at 15% 96%, rgba(251, 191, 36, 0.2), transparent 40%) !important;
}
.van-button--default {
	background: none !important;
	color: #528F86 !important;
}
.van-dialog__message {
	color: #fff !important;
}
.dhm-box {
	width: 100%;
	height: 100%;
	position: relative;
	position: fixed;
	left: 50%;
	top: 50%;
	transform: translate(-50%,-50%);
	z-index: 999;
	display: flex;
	align-items: center;
	justify-content: center;
	.box {
		width: 100%;
		max-width: 750px;
		position: relative;
		img {
			display: block;
			width: 100%;
			height: auto;
		}
		.off-btn {
			width: fit-content;
			height: fit-content;
			padding: 10px;
			border: 1px solid #fff;
			border-radius: 50%;
			color: #fff;
			background: rgba(7,53,36,0.4);
			font-size: 16px;
			position: absolute;
			right: 10%;
			top: 5%;
			z-index: 30;
		}
		.boxs {
			width: 100%;
			max-width: 750px;
			font-size: 20px;
			color: #fff;
			position: absolute;
			z-index: 10;
			bottom: 20%;
			padding: 0 20%;
			.title {
				margin-bottom: 10px;
			}
			.inputs {
				width: 100%;
				height: 40px;
				input {
					width: 100%;
					height: 100%;
					outline: #18be3c;
					background: #FFFFFF;
					border-radius: 10px;
					padding: 10px;
					font-size: 14px;
					color: #333;
				}
				input:focus {
					border: 1px solid #18be3c;
				}
			}
			.submit {
				width: 100%;
				height: 38px;
				button {
					width: 100%;
					height: 100%;
					font-size: 14px;
					color: #2d2d2d;
					font-weight: bold;
					background: #3EDAA5;
					margin-top: 10px;
					border-radius:15px;
				}
			}
		}
	}
}
</style>
